// extracted by mini-css-extract-plugin
export var imgWrapper = "join-box-module--imgWrapper--kyMb-";
export var joinBox = "join-box-module--join-box--8g5UF";
export var joinContainer = "join-box-module--join-container--Lh5Nv";